import React, { Component } from 'react';
import { connect } from 'react-redux';
import {awardCategorySelector, awardRecipientSelector, awardSelector, chapterSelector} from "../redux/selectors";
import { fetchUserAwards } from "../redux/actions";
import {toArray} from "../common/util";
import AwardImage from "./AwardImage";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class UserAwards extends Component {
    componentDidMount() {
        this.props.getUserAwards(this.props.user.slug);
    }

    render() {
        const userAwards = toArray(this.props.chapters).map((chapter) => {
            if (toArray(this.props.awardRecipients.data).length > 0 && this.props.awardCategories.pending === 0) {

                let userAwards = toArray(this.props.awardRecipients.data).filter(item => item.recipient === Number(this.props.user.id));
                /* eslint-disable no-sequences */
                const userAwardsConsolidated = userAwards.reduce((item, o) => (item[o.award] = (item[o.award] || 0) + 1, item), {});
                let awardList = [];
                for (let key in userAwardsConsolidated) {
                    awardList.push({award: this.props.awards[key], level: userAwardsConsolidated[key]})
                }
                let filteredAwardList = awardList.filter(item => this.props.awardCategories.data[item.award.category].chapter === chapter.id);
                return (
                    <ul key={chapter.id} className="award-list">
                        {filteredAwardList.length > 0 ? (
                            <li className="award-item"><h5>{chapter.game.title}</h5></li>
                        ) :('')
                        }
                        {filteredAwardList
                            .sort((a, b) => this.props.awardCategories.data[a.award.category].order - this.props.awardCategories.data[b.award.category].order || a.award.order - b.award.order)
                            .map((award, i) => (
                            <li key={i} className="award-item"><AwardImage award={award.award} level={award.level}/></li>
                        ))}
                    </ul>
                )
            } else {
                return null;
            }
        });
        if (this.props.awardRecipients.pending === 0) {
            return userAwards
        } else {
            return (
                <div><FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth /> Loading...</div>
            )
        }
    }
}

const mapStateToProps = (state) => ({
    chapters: chapterSelector(state),
    awards: awardSelector(state),
    awardCategories: awardCategorySelector(state),
    awardRecipients: awardRecipientSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getUserAwards: (user) => dispatch(fetchUserAwards(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserAwards);


// WEBPACK FOOTER //
// ./src/Awards/UserAwards.js